import {
  enableProdMode,
  importProvidersFrom,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withInterceptors,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { provideOktaAuth, withOktaConfig } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";

import { AppComponent } from "./app/app.component";
import { AppRoutingModule } from "./app/app-routing.module";
import { loadRuntimeConfig } from "./app/app.module"; // re-use existing function
import { environment } from "./environments/environment";
import { authInterceptor } from "./app/interceptors/auth.interceptor";

if (environment.production) {
  enableProdMode();
}

// Same as oktaConfigFactory, but returns OktaAuth instance directly
export function oktaAuthFactory(): OktaAuth {
  const env = (globalThis as any).__env || {};
  const issuer = env.issuer || env.oktaIssuer;
  const clientId = env.clientId || env.oktaClientId;

  if (!issuer || !clientId) {
    throw new Error(
      "Missing Okta runtime config: issuer/clientId. Check assets/config/runtime-config.json",
    );
  }

  return new OktaAuth({
    clientId,
    issuer,
    redirectUri: env.redirectUri || globalThis.location.origin,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    tokenManager: {
      storage: "memory",
      autoRenew: true,
      expireEarlySeconds: 60,
    },
  });
}

async function main(): Promise<void> {
  try {
    // Load runtime config first so Okta config values exist before creating OktaAuth.
    const initializerFn = loadRuntimeConfig();
    await initializerFn();

    await bootstrapApplication(AppComponent, {
      providers: [
        // Okta
        provideOktaAuth(withOktaConfig({ oktaAuth: oktaAuthFactory() })),

        // Router
        importProvidersFrom(AppRoutingModule),

        // HttpClient & interceptors
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor])),

        // Angular Material animations
        importProvidersFrom(BrowserAnimationsModule),

        // Shared services
      ],
    });
  } catch (err) {
    console.error(err);
  }
}

void main(); // NOSONAR - Angular application builder does not support top-level await in main entrypoint
